import vInput from "./v-input.vue";

export default Vue => {
  Vue.component("v-input", vInput);
};
